// src/components/About.js
import React from "react";
import about from "../../assets/img/about/about-1.webp";
import parlour from "../../assets/img/cart/parlour.PNG";

const HomeAbout = () => {
  return (
    <div>
      <div className="py-6 lg:py-6 px-4">
        <section id="about">
          {/* Section Title */}
          <div className=" section-title p-1" data-aos="fade-up">
            <span className="subtitle">About</span>
            {/* <h3>WE DESIGN & MANUFACTURE</h3> */}
          </div>
          {/* End Section Title */}
          <div className="container">
            <div data-aos="fade-up" data-aos-delay="100">
              <div className="flex flex-col lg:flex-row items-start gap-10">
                {/* Left Content */}
                <div
                  className="w-full lg:w-1/2"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <div className="space-y-5 italic leading-7  md:text-xl ">
                    {/* Quote Icon */}
                    <div
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-full mb-6 text-[1.75rem]"
                      style={{
                        backgroundColor:
                          "color-mix(in srgb, #c85716, transparent 90%)",
                        color: "#c85716",
                      }}
                    >
                      <i className="bi bi-quote"></i>
                    </div>

                    {/* Paragraphs */}
                    {/* <p>
                      We introduce ourselves as a leading manufacturer of
                      tricycle carts, tricycle rickshaws, e-carts, and
                      e-rickshaws, specializing in all types of Ice Cream Carts.
                    </p> */}

                    <p>
                      CART STUDIO is a trusted leader in Tricycle Carts,
                      Rickshaws, E-Carts, and E-Rickshaws, with a specialization
                      in custom Ice Cream Carts. Backed by engineering
                      excellence and partnerships with top brands like Amul,
                      Creambell, Havmor, Hocco Kwality Walls(Hindustan
                      Unilever), London Dairy, Mother Dairy, Namaste India,
                      Rollick, Vadilal, and many more. We deliver eco-friendly,
                      durable, and innovative mobility solutions for businesses
                      and communities.
                    </p>
                  </div>
                </div>

                {/* Right Image */}
                <div
                  className="w-full lg:w-[40%] py-10"
                  data-aos="fade-left"
                  data-aos-delay="300"
                >
                  <div className="overflow-hidden rounded-lg shadow-lg transform transition duration-300 hover:scale-105 h-[400px]">
                    <img
                      src={parlour}
                      alt="About us"
                      className="w-full h-full object-contain p-4 transition-all duration-300"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomeAbout;
